(() => {
  const SELECTORS = {
    slider: '.mf-fade-slider',
    slide: '.mf-fade-slide',
    dot: '.mf-fade-slider__dot',
    meta: '.mf-fade-slider__meta-item'
  };

  class FadeSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll(SELECTORS.slide));
      this.dots = Array.from(root.querySelectorAll(SELECTORS.dot));
      this.metaItems = Array.from(root.querySelectorAll(SELECTORS.meta));
      this.index = 0;
      this.timer = null;
      const interval = Number(root.dataset.interval);
      this.interval = Number.isFinite(interval) && interval > 0 ? interval : 5000;
      this.auto = root.dataset.autoplay !== 'false';

      if (this.slides.length === 0) return;

      this.bind();
      this.show(this.index, false);
      this.start();
    }

    bind() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const nextIndex = Number(dot.dataset.index || 0);
          this.show(nextIndex, true);
        });
      });

      this.root.addEventListener('mouseenter', () => this.stop());
      this.root.addEventListener('mouseleave', () => this.start());
      this.root.addEventListener('focusin', () => this.stop());
      this.root.addEventListener('focusout', () => this.start());
    }

    show(nextIndex, userTriggered) {
      const total = this.slides.length;
      if (total === 0) return;
      const index = ((nextIndex % total) + total) % total;
      this.index = index;

      this.slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('a, button, input, [tabindex]').forEach((el) => {
          if (isActive) {
            if (el.dataset.prevTabindex !== undefined) {
              el.setAttribute('tabindex', el.dataset.prevTabindex);
              delete el.dataset.prevTabindex;
            } else {
              el.removeAttribute('tabindex');
            }
          } else {
            if (el.getAttribute('tabindex') !== null) {
              el.dataset.prevTabindex = el.getAttribute('tabindex');
            }
            el.setAttribute('tabindex', '-1');
          }
        });
      });

      this.dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (this.metaItems.length > 0) {
        this.metaItems.forEach((item) => {
          const itemIndex = Number(item.dataset.index || 0);
          const isActive = itemIndex === index;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
        });
      }

      if (userTriggered) {
        this.restart();
      }
    }

    next() {
      this.show(this.index + 1, false);
    }

    start() {
      if (!this.auto || this.slides.length < 2) return;
      if (this.timer) return;
      this.timer = setTimeout(() => {
        this.timer = null;
        this.next();
        this.start();
      }, this.interval);
    }

    stop() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }

    destroy() {
      this.stop();
    }
  }

  const init = (root = document) => {
    root.querySelectorAll(SELECTORS.slider).forEach((slider) => {
      if (slider.__mfFadeSlider) slider.__mfFadeSlider.destroy();
      slider.__mfFadeSlider = new FadeSlider(slider);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTORS.slider).forEach((slider) => {
      if (slider.__mfFadeSlider) slider.__mfFadeSlider.destroy();
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = document.querySelector(
      `${SELECTORS.slide}[data-block-id="${event.detail.blockId}"]`
    );
    if (!slide) return;
    const slider = slide.closest(SELECTORS.slider);
    if (!slider || !slider.__mfFadeSlider) return;
    slider.__mfFadeSlider.show(Number(slide.dataset.index || 0), true);
    slider.__mfFadeSlider.stop();
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const slide = document.querySelector(
      `${SELECTORS.slide}[data-block-id="${event.detail.blockId}"]`
    );
    if (!slide) return;
    const slider = slide.closest(SELECTORS.slider);
    if (!slider || !slider.__mfFadeSlider) return;
    slider.__mfFadeSlider.start();
  });
})();
